import { useEffect, useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import CustomModal from 'components/global/CustomModal'
import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import NotesTab from '../Common/NotesTab'
import CheckInOutTab from '../Common/CheckInOutTab'
import HistoryTab from '../Common/HistoryTab'
import { useGetFamilyMembers } from 'api/family/family'
import {
  CheckINOutAttendee,
  CheckinOutAttendeeWithType,
} from 'types/event/eventAttendance'

interface CheckInStateTypes {
  checkInModalOpen: boolean
  setCheckInModalOpen: (value: boolean) => void
  setParticipantData: (value: CheckinOutAttendeeWithType) => void
  setCheckInOutModalOpen: (value: boolean) => void
}

const CheckInModal = () => {
  const [tabKey, setTabKey] = useState<string>('1')
  const {
    checkInModalOpen,
    setCheckInModalOpen,
    setParticipantData,
    setCheckInOutModalOpen,
  } = eventAttendanceStore(store => ({
    checkInModalOpen: store.checkInModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setCheckInModalOpen: store.setCheckInModalOpen,
    setParticipantData: store.setParticipantData,
  }))

  const closeModal = () => {
    setParticipantData(null)
    setCheckInOutModalOpen(true)
    setCheckInModalOpen(false)
  }

  return (
    <>
      <CustomModal
        openModal={checkInModalOpen}
        isCloseModalCustom
        closeModal={closeModal}
        title="Check-ins details"
        width={1200}
        footer={false}
      >
        <>
          <Tabs className="" defaultActiveKey={tabKey}>
            <TabPane tab="Notes" key="1">
              <NotesTab />
            </TabPane>
            <TabPane tab="Check-in" key="2">
              <CheckInOutTab type="check-in" />
            </TabPane>
            <TabPane tab="History" key="3">
              <HistoryTab />
            </TabPane>
          </Tabs>
        </>
      </CustomModal>
    </>
  )
}

export default CheckInModal
